export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Store"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Untitled"])}
}